import React from 'react'
import Grid from "@material-ui/core/Grid";
import { useStyle } from "./Style";
import { formatDateLocale } from '../../../../../lib/utils.es6';

// Extract a human-readable message from the backend error payload.
// The payload can be a plain string, or an object shaped like
// { message, error, statusCode } where `message` may itself contain a
// nested stringified error, e.g.
// "Failed ..., {\"message\":[\"quotation_guid must be a string\"], ...}"
// It can also be the underwriter engine's shape,
// { success: false, error: { message }, errorType }, used by claims routed
// through /api/onboard_claim (e.g. omk, omu_flp) instead of straight to
// claims-administration-dcp.
const getErrorMessage = (error) => {
  if (!error) return null;

  if (typeof error === 'string') return error;

  let message =
    error.message ||
    (typeof error.error === 'string' ? error.error : error.error && error.error.message) ||
    'An unexpected error occurred';

  if (Array.isArray(message)) {
    return message.join(', ');
  }

  if (typeof message === 'string') {
    // Try to surface nested validation messages when present.
    const match = message.match(/\{.*\}/);
    if (match) {
      try {
        const nested = JSON.parse(match[0]);
        const nestedMessage = nested.message || nested.error;
        if (Array.isArray(nestedMessage)) {
          return nestedMessage.join(', ');
        }
        if (nestedMessage) {
          return nestedMessage;
        }
      } catch (e) {
        // Not valid JSON, fall back to the raw message.
      }
    }
    return message;
  }

  return 'An unexpected error occurred';
};

const ClaimDetails = (props) => {
  const classes = useStyle();
  if (props.initiateClaimLoader) {
    return (
      <>
        <Grid container spacing={2} className={classes.headingclaim}>
          <Grid item xs={12} sm={12} md={12}>
            <h4>Claim Details</h4>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <p style={{ textAlign: "center" }}>...Submittng claim</p>
          </Grid>
        </Grid>
      </>
    );
  }

  const errorMessage = getErrorMessage(props.initiateClaimError);

  if (!props.claimDetailsData)
    return (
      <>
        <Grid container spacing={2} className={classes.headingclaim}>
          <Grid item xs={12} sm={12} md={12}>
            <h4>Claim Details</h4>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            {errorMessage ? (
              <div className={classes.errorWrapper}>
                <p>{errorMessage}</p>
              </div>
            ) : (
              <p>nothing found yet</p>
            )}
          </Grid>
        </Grid>
      </>
    );

  return (
    <>
      <Grid container spacing={2} className={classes.headingclaim}>
        <Grid item xs={12} sm={12} md={12}>
          <h4>Claim Details</h4>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <div className={classes.claimDetailsWrapper}>
            <table>
              <tr>
                <th>Claim Number</th>
                <th>Claim Status</th>
                <th>Event Date</th>
                <th>Initiator Fullname</th>
                <th>Created At</th>
              </tr>
              <tr>
                <td>{props.claimDetailsData.claim_number}</td>
                <td>{props.claimDetailsData.status}</td>
                <td>{formatDateLocale(props.claimDetailsData.event_date)}</td>
                <td>{props.claimDetailsData.initiator_fullname}</td>
                <td>{formatDateLocale(props.claimDetailsData.created_at)}</td>
              </tr>
            </table>
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default ClaimDetails